import script from "./ResolveMain.vue?vue&type=script&lang=ts&setup=true"
export * from "./ResolveMain.vue?vue&type=script&lang=ts&setup=true"

import "./ResolveMain.vue?vue&type=style&index=0&id=d9ba084e&scoped=true&lang=css"

import exportComponent from "/Users/niming/Documents/vue-mooc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d9ba084e"]])

export default __exports__